import { toast } from 'react-toastify';
import { convertPageableResponse } from '../../utils/responseMapper';
import * as api from '../api/usersApi';
import * as types from '../constants/usersConstants';

export const getUsersActions = (search) => async (dispatch) => {
  dispatch({ type: types.GET_USERS_REQUEST });
  try {
    const { error, data } = await api.getUsers(search);
    if (error) {
      throw new Error(error);
    }

    const { content, ...paginationData } = data;
    const pageable = convertPageableResponse(paginationData);

    dispatch({
      type: types.GET_USERS_SUCCESS,
      payload: {
        data: content,
        pageable: pageable,
      },
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити список користувачів');
    dispatch({ type: types.GET_USERS_FAILURE });
  }
};

export const updateUserAction = (user) => async () => {
  try {
    const { error } = await api.updateUser(user);
    if (error) {
      throw new Error(error);
    }
    toast.success('Користувач був успішно зміненений');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося змінити інформацію користувача');
  }
};

export const createUserAction = (user) => async () => {
  try {
    const { error } = await api.createUser(user);
    if (error) {
      throw new Error(error);
    }
    toast.success('Користувач був успішно зареєстрований');
  } catch (error) {
    toast.error(error?.message ? error.message : toast.error('Не вдалося зареєстувати користувача'));
  }
};

export const deactivateUserAction = (user) => async () => {
  try {
    const { error } = await api.deactivateUser(user);
    if (error) {
      throw new Error(error);
    }
    toast.success('Користувач був успішно заблокований');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося заблокувати користувача');
  }
};

export const activateUserAction = (user) => async () => {
  try {
    const { error } = await api.activateUser(user);
    if (error) {
      throw new Error(error);
    }
    toast.success('Користувач був успішно розблокований');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося розблокувати користувача');
  }
};

export const clearUsersActions = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_USERS,
  });
};

export const setUsersPageSizeAction = (pageSize) => async (dispatch) => {
  dispatch({
    type: types.SET_USERS_PAGE_SIZE,
    payload: pageSize,
  });
};

export const setSelectedUserAction = (user) => async (dispatch) => {
  dispatch({
    type: types.SELECT_USER,
    payload: user,
  });
};

export const clearSelectedUserAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_SELECTED_USER,
  });
};

export const setUsersSearchAction = (search) => async (dispatch) => {
  dispatch({
    type: types.SET_USERS_SEARCH,
    payload: search,
  });
};

export const nextUsersPageAction = () => async (dispatch) => {
  dispatch({
    type: types.NEXT_USERS_PAGE,
  });
};

export const prevUsersPageAction = () => async (dispatch) => {
  dispatch({
    type: types.PREV_USERS_PAGE,
  });
};
